import React, { useState, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { hasPermission, createHistory, hasAtLeastOnePermission } from '../../sc-utilities';
import ChassisTypeList from './ChassisTypeList';
import { FindInPage } from '@material-ui/icons';

const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        paddingLeft: theme.spacing(-1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const ChassisType = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, chassisTypeID: null, redirectPath: '' });

    let visible = columns && columns['ChassisType'];
    const tableColumns = useMemo(() => {
        return [{
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {
                    hasPermission(permissions, 'chassis_type_load') ? <Tooltip title={translations["chassis_type_details"] || "Chassis type details"}>
                        <IconButton value={rowData.PairID} aria-label={translations["chassis_type_details"] || "Chassis type details"} onClick={() => redirectHandler(`/settings/chassis-type/edit?pairID=${rowData.PairID}`)}>
                            <FindInPage />
                        </IconButton>
                    </Tooltip> : ''
                }
            </>
        },
        {
            title: translations["key"] || 'Key', field: 'TypeKey',
            hidden: visible ? visible['TypeKey'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.TypeKey ? rowData.TypeKey : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["value"] || 'Value', field: 'TypeValue',
            hidden: visible ? visible['TypeValue'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.TypeValue ? rowData.TypeValue : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["system"] || 'System', field: 'System',
            hidden: visible ? visible['System'] : false,
            filtering: true,
            lookup: { '1': translations["system"] || 'System', '0': translations["custom"] || 'Custom' },
            defaultFilter: ['0', '1'],
            render: rowData => {
                return <Typography variant={'caption'}>{!rowData.CustomerID ? translations["system"] || 'System' : translations["custom"] || 'Custom'}</Typography>;
            }
        }
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classes, translations, visible])
    if (!hasAtLeastOnePermission(permissions, ['chassis_type_load'])) {
        tableColumns.shift();
    }

    const redirectHandler = (path, chassisTypeID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, chassisTypeID: chassisTypeID, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'chassis_type_list') ?
                <ChassisTypeList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(ChassisType));
